import type { MangaItem } from '@/mocks/manga';
import { formatViews } from '@/mocks/manga';

interface MangaCardProps {
  item: MangaItem;
}

export default function MangaCard({ item }: MangaCardProps) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg bg-background-100 ring-1 ring-background-200/70 transition hover:-translate-y-1 hover:ring-primary-500/40">
      <a href="#reading" className="relative block overflow-hidden">
        <div className="relative aspect-[2/3] w-full overflow-hidden">
          <img
            src={item.cover}
            alt={`${item.title} - ${item.subtitle}，${item.category}免费漫画高清封面`}
            title={`${item.title} ${item.subtitle}`}
            className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
          />
        </div>
        <div className="absolute left-2 top-2 rounded-full bg-background-950/80 px-2 py-0.5 text-[11px] text-accent-400 backdrop-blur">
          {item.status}
        </div>
        <div className="absolute inset-x-0 bottom-0 flex items-end justify-between bg-gradient-to-t from-background-950/90 to-transparent p-2.5">
          <span className="text-[11px] text-foreground-300">{item.latestChapter}</span>
          <span className="flex items-center gap-1 text-[11px] text-foreground-400">
            <i className="ri-eye-line" />
            {formatViews(item.views)}
          </span>
        </div>
      </a>
      <div className="flex flex-col gap-1 p-3">
        <h3 className="truncate text-sm font-bold text-foreground-950">{item.title}</h3>
        <p className="truncate text-xs text-foreground-600">{item.subtitle}</p>
        <div className="mt-1 flex flex-wrap items-center gap-1.5">
          <span className="rounded-full bg-primary-500/15 px-2 py-0.5 text-[11px] text-primary-400">
            {item.category}
          </span>
          <span className="flex items-center gap-0.5 text-[11px] text-foreground-600">
            <i className="ri-star-fill text-accent-400" />
            {item.rating}
          </span>
        </div>
      </div>
    </article>
  );
}